import {EventEmitter} from './event-emitter';

export class SetSticky {
	constructor(elem) {
		this.elem = elem;

		this.offset = this.elem.offsetTop;
		this.windowWidth = window.innerWidth;
		this.elementHeight = this.elem.offsetHeight;
		this.parentElement = this.elem.parentElement || '';
		this.computedParentPaddingTop = this.parentElement ? window.getComputedStyle(this.parentElement).paddingTop : '0';
		this.parentPaddingTop = parseInt(this.computedParentPaddingTop);
		this.init();
	}

	init() {
		this.setSticky();
		this.addEventHandlers();
	}

	addEventHandlers() {
		EventEmitter.on('ScrollDetector:scroll', () => {
			this.setSticky();
		});
		window.addEventListener('resize', () => {
			if(window.innerWidth !== this.windowWidth){
				this.windowWidth = window.innerWidth;
				this.parentElement.style.paddingTop = null;
				this.computedParentPaddingTop = this.parentElement ? window.getComputedStyle(this.parentElement).paddingTop : '0';
				this.elem.classList.remove('_is-sticky');
				this.offset = this.elem.offsetTop;
			}
		})
	}

	setSticky() {
		if (window.pageYOffset >= this.offset) {
			this.elem.classList.add('_is-sticky');
			if (this.parentElement) {
				this.parentElement.style.paddingTop = `${this.parentPaddingTop + this.elementHeight}px`;
			}
		} else {
			this.elem.classList.remove('_is-sticky');
			if (this.parentElement) {
				this.parentElement.style.paddingTop = this.computedParentPaddingTop;
			}
		}
	}

	static getSelector() {
		return '[data-set-sticky]';
	}
}
